<div class="individual-form-component">
  <form [formGroup]="formGroup">
    @if (roleLabel) {
      <div class="row">
        <div class="col-12">
          <div class="application-subsection-title">{{headerName()}} - {{roleLabel}}</div>
        </div>
      </div>
    }

    <div class="row">
      <div class="col-lg-4 col-md-12">
        <name title="First Name" [mark]="markObservable" [formControl]="formControlFirstName"></name>
      </div>
      <div class="col-lg-4 col-md-12">
        <name title="Middle Name" [mark]="markObservable" [mandatory]="false" [formControl]="formControlMiddleName"></name>
      </div>
      <div class="col-lg-4 col-md-12">
        <name title="Last Name" [mark]="markObservable" [formControl]="formControlLastName"></name>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 col-md-12">
        <title-selection
          [mark]="markObservable"
          [formControl]="formControlTitle">
        </title-selection>
      </div>
      <div class="col-lg-4 col-md-12">
        <yes-no
          title="Do they have any aliases (maiden names, nicknames, etc)?"
          [mark]="markObservable"
          [formControl]="formControlHasAlias">
        </yes-no>
      </div>
      @if (formControlHasAlias.value) {
        <div class="col-lg-4 col-md-12">
          <mat-form-field>
            <mat-label>If Yes, please provide the other name(s)</mat-label>
            <input matInput type="text" maxlength="500" [formControl]="formControlAliasNames" [disableControl]="disabled">
            @for (errorKey of errorKeys(formControlAliasNames); track errorKey) {
              <mat-error>
                @if (formControlAliasNames.touched && formControlAliasNames.hasError(errorKey)) {
                  {{errorMessage(formControlAliasNames, errorKey)}}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
    </div>

    <div class="row">
      <div class="col-lg-4 col-md-12">
        <email [mark]="markObservable"
          [mandatory]="true"
          (events)="onEmailEvent($event)"
          [formControl]="formControlEmail">
        </email>
      </div>
      <div class="col-lg-4 col-md-12">
        <mobile
          [mark]="markObservable" [mandatory]="true"
          [onlyMobile]="true"
          (events)="onMobileEvent($event)"
          [formControl]="formControlMobileNumber">
        </mobile>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 col-md-12">
        <datepicker
          [mark]="markObservable"
          title="Date of birth"
          [allowOnly18YrsPlus]="true"
          [formControl]="formControlDob">
        </datepicker>
      </div>
      <div class="col-lg-4 col-md-12">
        <mat-form-field class="citizenship-field" appearance="outline">
          <mat-label>Country of Citizenship</mat-label>
          <mat-select
            panelClass="citizenship-select-panel"
            placeholder="Select Country..."
            [formControl]="formControlCountryOfCitizenship"
            [disableControl]="disabled">
            @for (option of countryOptions; track option.code) {
              <mat-option [value]="option">{{option.name}}</mat-option>
              @if (option.code === 'AU') {
                <mat-divider class="citizenship-country-divider"></mat-divider>
              }
            }
          </mat-select>
          @for (errorKey of errorKeys(formControlCountryOfCitizenship); track errorKey) {
            <mat-error>
              @if (formControlCountryOfCitizenship.touched && formControlCountryOfCitizenship.hasError(errorKey)) {
                {{errorMessage(formControlCountryOfCitizenship, errorKey)}}
              }
            </mat-error>
          }
          @if (showCitizenshipResidencyAlert()) {
            <mat-hint class="citizenship-residency-alert">Proof of Australian permanent residency may be required.</mat-hint>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-8 col-md-12">
        <custom-address
          [placesSearchResultFn]="placesSearchResultFn"
          [placesDetailsFn]="placesDetailsFn"
          [mark]="markObservable"
          title="Residential address"
          [formControl]="formControlResidentialAddress">
        </custom-address>
      </div>
    </div>

    @if (showPropertyOwner) {
      @if (withPropertyOwnerAddress) {
        <div class="row">
          <div class="col-12">
            <property-owner-with-address
              [mark]="markObservable"
              [formControl]="formControlPropertyOwner"
              [copyAddressFn]="getAddress2ComponentValueFormControlValueFn(formControlResidentialAddress)"
              [showAddressForm]="showAddressForm">
            </property-owner-with-address>
          </div>
        </div>
      } @else {
        <div class="row">
          <div class="col-lg-4 col-md-12">
            <yes-no title="Property owner"
              [mark]="markObservable"
              [formControl]="formControlPropertyOwner">
            </yes-no>
          </div>
        </div>
      }
    }

    @if (showIdentification) {
      <div class="row">
        <div class="col-12">
          <identification
            [mandatory]="true"
            [mark]="markObservable"
            [formControl]="formControlIdentification">
          </identification>
        </div>
      </div>
      @if (showIdDocumentUpload) {
        <div class="row separator-bottom">
          <div class="col-lg-8 col-md-12">
            <upload-file
              title="Upload ID Document"
              [mandatory]="idDocumentRequired"
              [mark]="markObservable"
              [allowMultiple]="true"
              [maxFilesAllowed]="maxIdDocuments"
              [acceptFileTypes]="['.pdf', '.png', '.jpg', '.jpeg', 'image/*']"
              [formControl]="formControlIdDocument">
            </upload-file>
            @if (existingIdDocuments.length) {
              <uploaded-files-list
                [uploadedFiles]="existingIdDocuments"
                [isAzureDocument]="true"
                (events)="onDeleteIdDocument($event)">
              </uploaded-files-list>
            }
          </div>
        </div>
      }
    }
  </form>
</div>
